import { Resources } from "Infrastructure/Translations/Resources";
import { useTheme } from "@mui/material";

export const useRequestStatusConfig = () => {
  const { colors } = useTheme();

  return {
    Requested: {
      labelKey: Resources.RequestCards.RequestDetail.StatusValues.Requested,
      colorKey: colors.background.warningTertiary,
    },
    Active: {
      labelKey: Resources.RequestCards.RequestDetail.StatusValues.Active,
      colorKey: colors.background.successTertiary,
    },
    Pending: {
      labelKey: Resources.RequestCards.RequestDetail.StatusValues.Pending,
      colorKey: colors.background.dangerTertiary,
    },
    Completed: {
      labelKey: Resources.RequestCards.RequestDetail.StatusValues.Completed,
      colorKey: colors.background.tertiary,
    },
    Canceled: {
      labelKey: Resources.RequestCards.RequestDetail.StatusValues.Canceled,
      colorKey: colors.background.secondary,
    },
  };
};
